import request from '@/utils/request';

export default {
    createRequestReason: async({ dispatch, commit }, data) => {
        await request({ method: 'post', url: '/reason', data })
            .then((res) => {
                if (res.data) {
                    commit('ADD_REASON', res.data);
                    dispatch('alert/addMessage', {
                        message: 'success',
                        type: 'success'
                    }, { root: true });
                }
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    },


    getReasons: async({ dispatch, commit }, { page, name }) => {
        await request({ method: 'get', url: '/reason', params: { page, name } })
            .then((res) => {
                commit('SET_REASONS', res.data.items);
                commit('SET_PAGINATION', { page: res.data.page, totalPages: res.data.totalPages });
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    },

    deleteReason: async({ dispatch, commit }, id) => {
        await request({ method: 'delete', url: `/reason/${id}`})
            .then((res) => {
                commit('DELETE_REASON', res.data);
                commit('SET_PAGINATION', { totalPages: res.data.totalPages });
                dispatch('alert/addMessage', {
                    message: 'success',
                    type: 'success'
                }, { root: true });
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    },

    editRequestReason: async({ dispatch, commit }, reason) => {
        await request({ method: 'put', url: `reason/${reason.id}`, data: {
            ...Object.select(reason, ['name', 'types'])
        }})
            .then((res) => {
                commit('EDIT_REASON', res.data);
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    },

    getAllReasons: async({ dispatch, commit }) => {
        await request({ method: 'get', url: '/reason/all' })
            .then(res => {
                commit('SET_REASONS', res.data);
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    }
};
